<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Defect retourné</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Reference</th>
          <th class="px-6 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Brand</th>
          <th class="px-6 pt-6 pb-4">Category</th>
          <th class="px-6 pt-6 pb-4">Type</th>
          <th class="px-6 pt-6 pb-4">Quantité</th>
          <th class="px-6 pt-6 pb-4">Envoyer par</th>
          <th class="px-6 pt-6 pb-4">Creation date</th>
        </tr>
        <tr v-for="defect in defects.data" :key="defect.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.stock.reference }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.imei }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.stock.model.name }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.stock.brand ? defect.stock.brand.name : "" }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.stock.category.name }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.stock.type }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.quantity }}
            </span>
          </td>
          <td class="border-t">
            <span v-if="defect.repair_id != null" class="px-6 py-4 flex items-center">
              {{ defect.shop_name }}
            </span>
            <span v-else class="px-6 py-4 flex items-center">
              -RETOUR-
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center">
              {{ defect.created_at }}
            </span>
          </td>
        </tr>
        <tr v-if="defects.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No defect found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="defects.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo: {title: 'Defect'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
  },
  props: {
    errors: Object,
    defects: Object,
    filters: Object,
  },
  data() {
    return {
      selected: [],
      selectAll: false,
      sending: false,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('defect.returnedList', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
